import { hasValue } from "@repo/helpers";
import { useCallback } from "react";

import { useSelectorLogic } from "../../dropDownList/selectorHook";
import { DdlValue } from "../../dropDownList/types";
import { Button, ButtonSize, ButtonTypes } from "../../index";
import PanelMarkup from "./markupPanel";
import RadioButtonListMarkup from "./markupRadioButtonList";
import { Props } from "./types";

export function Selector(props: Props) {
	const { value, setValueFn: setValue, mapToValue } = useSelectorLogic(props);
	const { renderAsPanels, values, isMulti } = props;

	// Adds or removes item from a list (handles if multi, so array)
	const valueChangedMulti = useCallback(
		function (ddlValue: DdlValue) {
			if (!Array.isArray(value)) return;
			const arrValue = [...value];
			const indexOf = arrValue.findIndex((v) => v.value === ddlValue.value);
			if (indexOf > -1) arrValue.splice(indexOf, 1);
			else arrValue.push(ddlValue);
			setValue([...arrValue]);
		},
		[setValue, value],
	);

	const valueChanged = useCallback(
		function (val: any) {
			const ddlValue = values.map(mapToValue).filter((v) => v.value === val)[0];
			if (isMulti) valueChangedMulti(ddlValue);
			else setValue(ddlValue);
		},
		[valueChangedMulti, mapToValue, setValue, values],
	);

	const clear = useCallback(
		function () {
			if (isMulti) setValue([]);
			else setValue(null);
		},
		[isMulti, setValue],
	);

	const MarkupType = renderAsPanels ? PanelMarkup : RadioButtonListMarkup;
	return (
		<MarkupType
			{...props}
			value={value}
			clearButton={renderClearButton()}
			valueChanged={valueChanged}
			key={props.id}
		/>
	);

	function renderClearButton() {
		const { value, clearable } = props;
		if (hasValue(value) && clearable)
			return (
				<Button onClick={clear} size={ButtonSize.small} types={[ButtonTypes.Circle]}>
					Clear
				</Button>
			);
		return null;
	}
}

export default Selector;
